module.exports = __webpack_public_path__ + "img/xiaohongshu_round.2a31dea9.svg";